import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isFunction from "lodash/isFunction";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-property.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable camelcase */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, DeleteConfirmationModal, useUser } from 'components';
import { getDocumentForPayment, deletePaymentForCredit } from 'services';
import { dateFormat, PAYMENT_DOCUMENT_STATUS, paymentTypeName, CREDIT_PAYMENT_TYPE } from 'enums';
import { showApiError, convertToAdditionalCurrency, oppositeCurrency } from 'utils';
import { jsx as ___EmotionJSX } from "@emotion/react";
var waiting_sign = PAYMENT_DOCUMENT_STATUS.waiting_sign,
    signed = PAYMENT_DOCUMENT_STATUS.signed;

var tableContainer = function tableContainer(theme) {
  return {
    border: "1px solid ".concat(theme.gray100)
  };
};

var tableHead = function tableHead(theme) {
  return {
    display: 'flex',
    padding: '0 1.5em',
    backgroundColor: theme.gray50
  };
};

var tableRow = function tableRow() {
  var isCorected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (theme) {
    return _objectSpread({
      display: 'flex',
      padding: '0 1.5em',
      borderBottom: "1px solid ".concat(theme.gray100),
      transition: 'background-color .2s ease',
      '&:last-of-type': {
        borderBottom: 'none'
      },
      '&:hover': {
        backgroundColor: theme.gray50
      }
    }, isCorected && {
      color: theme.warning
    });
  };
};

var cellStyle = function cellStyle() {
  var flex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1 1 100px';
  return {
    flex: flex,
    padding: '1.2em 0.7em',
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.3rem'
  };
};

var cellColumn = function cellColumn() {
  var flex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1 1 100px';
  return {
    flex: flex,
    padding: '1.2em 0.7em',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontSize: '1.3rem',
    '& > p': {
      margin: 0,
      lineHeight: 1.4
    }
  };
};

var headCellStyle = function headCellStyle() {
  var flex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1 1 100px';
  return function (theme) {
    return {
      flex: flex,
      padding: '1em 0.7em',
      color: theme.gray300,
      fontSize: '1.2rem',
      fontWeight: 600
    };
  };
};

var emptyStyle = function emptyStyle(theme) {
  return {
    padding: '2em',
    textAlign: 'center',
    color: theme.gray400
  };
};

var CreditPaymentsTable = function CreditPaymentsTable(_ref) {
  var creditId = _ref.creditId,
      payments = _ref.payments,
      onSign = _ref.onSign,
      onDelete = _ref.onDelete,
      creditPaymentType = _ref.creditPaymentType;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var isSeparatePayment = creditPaymentType === CREDIT_PAYMENT_TYPE.home_visit_fee_separate_payment;
  var canDelete = (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant) || (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isPartnerOrPartnerManager) && isSeparatePayment;
  var modalRef = useRef();
  var deleteRecordRef = useRef();

  var handleDocument = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(paymentId, documentId, isSign) {
      var _yield$getDocumentFor, _yield$getDocumentFor2, res, err, url;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getDocumentForPayment(paymentId, documentId);

            case 2:
              _yield$getDocumentFor = _context.sent;
              _yield$getDocumentFor2 = _slicedToArray(_yield$getDocumentFor, 2);
              res = _yield$getDocumentFor2[0];
              err = _yield$getDocumentFor2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              url = URL.createObjectURL(new File([res], 'filename.json', {
                type: 'application/pdf'
              }));
              if (isSign) _isFunction(onSign) && onSign({
                url: url,
                documentId: documentId,
                paymentId: paymentId
              });else window.open(url, '_blank');

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDocument(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDeleteDocument = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
      var _modalRef$current;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              deleteRecordRef.current = id;
              (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 ? void 0 : _modalRef$current.open();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDeleteDocument(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleDelete = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _yield$deletePaymentF, _yield$deletePaymentF2, res, err;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return deletePaymentForCredit(creditId, deleteRecordRef.current);

            case 2:
              _yield$deletePaymentF = _context3.sent;
              _yield$deletePaymentF2 = _slicedToArray(_yield$deletePaymentF, 2);
              res = _yield$deletePaymentF2[0];
              err = _yield$deletePaymentF2[1];

              if (!err) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 8:
              deleteRecordRef.current = null;
              _isFunction(onDelete) && onDelete(res);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleDelete() {
      return _ref4.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: tableContainer
  }, ___EmotionJSX("div", {
    css: tableHead
  }, ___EmotionJSX("div", {
    css: headCellStyle('0 0 50px')
  }, "ID"), ___EmotionJSX("div", {
    css: headCellStyle('0 0 110px')
  }, "\u0414\u0430\u0442\u0430"), ___EmotionJSX("div", {
    css: headCellStyle('1 1 140px')
  }, "\u0421\u043B\u0443\u0436\u0438\u0442\u0435\u043B"), ___EmotionJSX("div", {
    css: headCellStyle('0 0 140px')
  }, "\u041D\u0430\u0447\u0438\u043D \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435"), ___EmotionJSX("div", {
    css: headCellStyle('0 0 100px')
  }, "\u0421\u0443\u043C\u0430"), ___EmotionJSX("div", {
    css: headCellStyle('0 0 60px')
  }, "\u0412\u0430\u043B\u0443\u0442\u0430"), ___EmotionJSX("div", {
    css: headCellStyle('0 0 100px')
  }, "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u043E"), ___EmotionJSX("div", {
    css: headCellStyle('0 0 100px')
  }, "\u0421\u0442\u043E\u0440\u043D\u043E"), canDelete && ___EmotionJSX("div", {
    css: headCellStyle('0 0 90px')
  }, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435")), (payments === null || payments === void 0 ? void 0 : payments.length) > 0 ? payments.map(function (el) {
    var _el$employee, _el$payment_document, _el$payment_document3, _el$correction_docume, _el$correction_docume3;

    return ___EmotionJSX("div", {
      css: tableRow(!!(el !== null && el !== void 0 && el.is_corrected)),
      key: el === null || el === void 0 ? void 0 : el.id
    }, ___EmotionJSX("div", {
      css: cellStyle('0 0 50px')
    }, el === null || el === void 0 ? void 0 : el.id), ___EmotionJSX("div", {
      css: cellStyle('0 0 110px')
    }, moment(el === null || el === void 0 ? void 0 : el.date).isValid() ? moment(el === null || el === void 0 ? void 0 : el.date).format(dateFormat) : '--'), ___EmotionJSX("div", {
      css: cellStyle('1 1 140px')
    }, el === null || el === void 0 ? void 0 : (_el$employee = el.employee) === null || _el$employee === void 0 ? void 0 : _el$employee.name), ___EmotionJSX("div", {
      css: cellStyle('0 0 140px')
    }, paymentTypeName[el === null || el === void 0 ? void 0 : el.payment_type] || '-'), ___EmotionJSX("div", {
      css: cellColumn('0 0 100px')
    }, ___EmotionJSX("p", null, el === null || el === void 0 ? void 0 : el.amount), ___EmotionJSX("p", null, convertToAdditionalCurrency({
      value: el === null || el === void 0 ? void 0 : el.amount,
      fromCurrency: el === null || el === void 0 ? void 0 : el.currency,
      noLabel: true
    }))), ___EmotionJSX("div", {
      css: cellColumn('0 0 60px')
    }, ___EmotionJSX("p", null, el === null || el === void 0 ? void 0 : el.currency), ___EmotionJSX("p", null, oppositeCurrency(el === null || el === void 0 ? void 0 : el.currency))), ___EmotionJSX("div", {
      css: cellStyle('0 0 100px')
    }, (el === null || el === void 0 ? void 0 : el.payment_document) && ___EmotionJSX(React.Fragment, null, (el === null || el === void 0 ? void 0 : (_el$payment_document = el.payment_document) === null || _el$payment_document === void 0 ? void 0 : _el$payment_document.status) === signed && ___EmotionJSX(Button, {
      small: true,
      onClick: function onClick() {
        var _el$payment_document2;

        return handleDocument(el === null || el === void 0 ? void 0 : el.id, el === null || el === void 0 ? void 0 : (_el$payment_document2 = el.payment_document) === null || _el$payment_document2 === void 0 ? void 0 : _el$payment_document2.id);
      }
    }, "\u0412\u0438\u0436"), (el === null || el === void 0 ? void 0 : (_el$payment_document3 = el.payment_document) === null || _el$payment_document3 === void 0 ? void 0 : _el$payment_document3.status) === waiting_sign && ___EmotionJSX(Button, {
      small: true,
      type: "warning",
      onClick: function onClick() {
        var _el$payment_document4;

        return handleDocument(el === null || el === void 0 ? void 0 : el.id, el === null || el === void 0 ? void 0 : (_el$payment_document4 = el.payment_document) === null || _el$payment_document4 === void 0 ? void 0 : _el$payment_document4.id, true);
      }
    }, "\u041F\u043E\u0434\u043F\u0438\u0448\u0438"))), ___EmotionJSX("div", {
      css: cellStyle('0 0 100px')
    }, (el === null || el === void 0 ? void 0 : el.correction_document) && ___EmotionJSX(React.Fragment, null, (el === null || el === void 0 ? void 0 : (_el$correction_docume = el.correction_document) === null || _el$correction_docume === void 0 ? void 0 : _el$correction_docume.status) === signed && ___EmotionJSX(Button, {
      small: true,
      onClick: function onClick() {
        var _el$correction_docume2;

        return handleDocument(el === null || el === void 0 ? void 0 : el.id, el === null || el === void 0 ? void 0 : (_el$correction_docume2 = el.correction_document) === null || _el$correction_docume2 === void 0 ? void 0 : _el$correction_docume2.id);
      }
    }, "\u0412\u0438\u0436"), (el === null || el === void 0 ? void 0 : (_el$correction_docume3 = el.correction_document) === null || _el$correction_docume3 === void 0 ? void 0 : _el$correction_docume3.status) === waiting_sign && ___EmotionJSX(Button, {
      small: true,
      type: "warning",
      onClick: function onClick() {
        var _el$correction_docume4;

        return handleDocument(el === null || el === void 0 ? void 0 : el.id, el === null || el === void 0 ? void 0 : (_el$correction_docume4 = el.correction_document) === null || _el$correction_docume4 === void 0 ? void 0 : _el$correction_docume4.id, true);
      }
    }, "\u041F\u043E\u0434\u043F\u0438\u0448\u0438"))), canDelete && ___EmotionJSX("div", {
      css: cellStyle('0 0 90px')
    }, !!(el !== null && el !== void 0 && el.can_be_edited) && ___EmotionJSX(Button, {
      type: "secondary",
      small: true,
      onClick: function onClick() {
        return handleDeleteDocument(el === null || el === void 0 ? void 0 : el.id);
      }
    }, "\u0418\u0437\u0442\u0440\u0438\u0439")));
  }) : ___EmotionJSX("div", {
    css: emptyStyle
  }, "\u041D\u044F\u043C\u0430 \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u0438 \u0432\u043D\u043E\u0441\u043A\u0438.")), ___EmotionJSX(DeleteConfirmationModal, {
    modalRef: modalRef,
    onDelete: handleDelete
  }));
};

CreditPaymentsTable.propTypes = {
  creditId: PropTypes.number,
  payments: PropTypes.array,
  onSign: PropTypes.func,
  onDelete: PropTypes.func,
  noTitle: PropTypes.bool,
  creditPaymentType: PropTypes.string
};
export default CreditPaymentsTable;